/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { useTranslation } from "next-i18next";
import { IUserSubscriptionModel, PaymentPeriod } from "@nf/common";

import styles from "./PaymentDetailType.module.scss";

type PaymentDetailLabelProps = {
  subscription?: IUserSubscriptionModel & {
    CustomerCurrency?: string;
  };
  className?: string;
};

export const PaymentDetailType = ({
  className = "mt-md",
  subscription,
}: PaymentDetailLabelProps) => {
  const { t } = useTranslation("translations");

  const price =
    subscription?.NextPaymentPrice !== undefined
      ? `${subscription?.NextPaymentPrice || 0}`
      : undefined;
  const currency =
    subscription?.NextPaymentCurrency?.toLowerCase() ??
    subscription?.CustomerCurrency?.toLowerCase();
  const period = subscription?.Period;
  const isCancelled = subscription?.IsCancelled;

  if (!price || !currency) {
    return null;
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <span className={styles.title}>
        {period === PaymentPeriod.HalfYear
          ? t("web_subscription_6months")
          : t(`web_offer_subscription_period_${period}`)}
      </span>
      {!isCancelled && (
        <span className={styles.price}>{`${price} ${currency}.${t(
          `web_payment_period_${period}`
        )}`}</span>
      )}
    </div>
  );
};
